import '@images/i-menu.png';
import '@styles/app.scss';

/**
 * App script
 */

import CVRISKAdmin from '@scripts/controllers/Admin';
import CVRISKFront from '@scripts/controllers/Front';

document.addEventListener('DOMContentLoaded', () => {
  let controller = window?.cvriskPlugin?.admin
    ? new CVRISKAdmin()
    : new CVRISKFront();
  controller.boot();
});
